import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../providers/rest.service';
import {ToastrService} from 'ngx-toastr';
import {UrunGrup} from '../model/urun-grup';


@Component({
  selector: 'app-urun-grup-ekle-duzenle',
  templateUrl: './urun-grup-ekle-duzenle.component.html',
  styleUrls: ['./urun-grup-ekle-duzenle.component.css']
})
export class UrunGrupEkleDuzenleComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  id: string = null;
  urunGrup: UrunGrup = null;
  parentUrunGruplari: UrunGrup[] = null;
  showSelectUrunGrupModalTs: number = null; // farklı id vermek gerekiyor
  selectedParent: UrunGrup = null;


  constructor(private route: ActivatedRoute,
              private router: Router,
              private restService: RestService,
              private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.id = params.id;
      if (this.id !== '0') {
        this.getUrunGrup();
      } else {
        this.urunGrup = new UrunGrup();
        this.urunGrup.isim = '';
        this.urunGrup.tahminiTeslimGun = 0;
        this.urunGrup.parentId = null;
        this.getUrunGruplar();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getUrunGrup() {
    this.restService.getUrunGrup(this.id).subscribe(res => {
      if (res) {
        this.urunGrup = res;
        // console.log(this.urunGrup);
        this.selectedParent = this.urunGrup.parent;
        this.getUrunGruplar();
      }
    });
  }

  getUrunGruplar() {
    this.restService.urunGruplar(null).subscribe(res => {
      if (res) {
        this.parentUrunGruplari = res;
      }
    });
  }

  save() {
    const subscription = res => {
      this.toastrService.show('Kaydedildi', 'Başarılı');
      this.router.navigate(['urun-gruplar']);
    };
    this.urunGrup.parentId = this.selectedParent?.id;

    if (this.id === '0') {
      this.restService.urunGrupEkle(this.urunGrup).subscribe(subscription);
    } else {
      this.restService.urunGrupDuzenle(this.urunGrup).subscribe(subscription);
    }
  }


  kaldir(s: UrunGrup) {
    if (confirm(`${s.isim} ürün grubunu silmek istediğinize emin misiniz?`)) {
      this.restService.urunGrupSil(s.id).subscribe(res => {
        if (res) {
          this.getUrunGrup();
        }
      });
    }
  }

  incele(s: UrunGrup) {
    this.router.navigate(['urun-grup'], {queryParams: {id: s.id}});
  }

  showSelectUrunGrup() {
    this.showSelectUrunGrupModalTs = new Date().getTime();
  }

  selectUrunGrup(event: UrunGrup) {
    if (event) {
      this.selectedParent = event;
    }
  }

  clear() {
    this.selectedParent = null;
  }
}

